import React from 'react';

function IdleOverlayComponent({
  allowedLabel,
  metaItems,
  idleResumeError,
  continueLabel,
  onContinue,
  resumingIdle,
  resumeAction,
}) {
  return (
    <div className="idle-overlay" role="dialog" aria-label="Idle progression paused" aria-modal="true">
      <div className="idle-overlay__inner">
        <div className="idle-overlay__header">
          <div className="idle-overlay__title">Idle progression paused</div>
          {allowedLabel ? (
            <div className="idle-overlay__subtitle">
              Offline cap reached ({allowedLabel} min)
            </div>
          ) : null}
        </div>
        <div className="idle-overlay__content">
          <p>
            You've reached the offline progress limit, so automated actions stopped. Click continue to log an action and resume idle gains.
          </p>
          {metaItems.length > 0 && (
            <ul className="idle-overlay__meta">
              {metaItems.map((text, index) => (
                <li key={`idle-meta-${resumeAction}-${index}`}>{text}</li>
              ))}
            </ul>
          )}
        </div>
        {idleResumeError && <div className="idle-overlay__error" role="alert">{idleResumeError}</div>}
        <button
          type="button"
          className="idle-overlay__action"
          onClick={onContinue}
          disabled={resumingIdle}
        >
          {continueLabel}
        </button>
      </div>
    </div>
  );
}

const IdleOverlay = React.memo(IdleOverlayComponent);

export default IdleOverlay;
